/**
 * Admin Configuration
 *
 * ✅ SECURITY: Admin status is now stored in Firestore user profiles
 * No hardcoded emails - check the 'isAdmin' field in the user document instead
 *
 * To grant admin access:
 * 1. Go to Firebase Console → Firestore Database
 * 2. Navigate to: users/{userId}
 * 3. Add field: isAdmin = true
 *
 * Admin users automatically receive:
 * - Premium plan access
 * - Full feature access for testing
 */

/**
 * Get user plan based on admin status and existing plan
 * Admins automatically get premium access
 * @param {boolean} isAdmin - Admin status from Firestore
 * @param {string} existingPlan - Existing plan from database
 * @returns {string} - User plan ('premium' or 'free')
 */
export const getUserPlan = (isAdmin, existingPlan = 'free') => {
  if (isAdmin) {
    return 'premium';
  }
  return existingPlan;
};
